import React, { useEffect, useState } from "react";
import { auth } from "../firebase";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

export default function AccountPage() {
  const [user, setUser] = useState<any>(null);
  const [transactions, setTransactions] = useState<any[]>([]);

  useEffect(() => {
    setUser(auth.currentUser);
    // Fetch transactions from Firestore
    const fetchTransactions = async () => {
      const db = getFirestore();
      if (!auth.currentUser) return;
      const q = query(
        collection(db, "transactions"),
        where("userId", "==", auth.currentUser.uid)
      );
      const snapshot = await getDocs(q);
      setTransactions(snapshot.docs.map(doc => doc.data()));
    };
    fetchTransactions();
  }, []);

  if (!user) {
    return <div style={{ padding: 32 }}>Please log in to view your account.</div>;
  }

  return (
    <div style={{ maxWidth: 600, margin: "40px auto", padding: 24 }}>
      <h2>Account Details</h2>
      <div style={{ marginBottom: 24 }}>
        <strong>Email:</strong> {user.email}<br />
        <strong>User ID:</strong> {user.uid}
      </div>
      <h3>Transaction History</h3>
      {transactions.length === 0 ? (
        <div>No transactions found.</div>
      ) : (
        <ul>
          {transactions.map((tx, idx) => (
            <li key={idx}>
              <strong>Date:</strong> {tx.date} | <strong>Amount:</strong> €{tx.amount} | <strong>Description:</strong> {tx.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
